import {
  TablePage,
  AddPage,
  EditPage,
  ViewPage,
} from 'src/views/acihighway/arrivalcert'
import pathMap from 'src/paths/pathMap'

class ArrivalCertRoute {
  getConfigurations() {
    return [
      {
        exact: true,
        path: pathMap.ACI_HIGHWAY_INBOND_ARRIVAL_LIST_VIEW,
        component: TablePage
      },
      {
        exact: true,
        path: pathMap.ACI_HIGHWAY_INBOND_ARRIVAL_ADD_VIEW,
        component: AddPage
      },
      {
        exact: true,
        path: pathMap.ACI_HIGHWAY_INBOND_ARRIVAL_EDIT_VIEW,
        component: EditPage
      },
      {
        exact: true,
        path: pathMap.ACI_HIGHWAY_INBOND_ARRIVAL_DETAILS_VIEW,
        component: ViewPage
      }
    ]
  }
}

export default ArrivalCertRoute
